/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Button } from '@/components/button';
import { Col, Form, Row, Select } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { getListRoles, watchRoleList } from '@/redux/slices/roles.slice';

type UserAdminSearcherProps = {
  onSearch: (values: FilterAdminPermissions) => void;
};

export const UserAdminSearcher = ({ onSearch }: UserAdminSearcherProps) => {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const rolesList = useAppSelector(watchRoleList);

  const rolesOptions = useMemo(
    () => [
      { value: '', label: 'Tất cả' },
      ...rolesList.map((role) => ({
        value: role.id,
        label: role.name
      }))
    ],
    [rolesList]
  );

  const handleSearch = () => {
    const values = form.getFieldsValue();
    onSearch(values);
  };

  const handleClear = () => {
    form.resetFields();
    handleSearch();
  };

  useEffect(() => {
    dispatch(getListRoles());
  }, [dispatch]);

  return (
    <Form
      form={form}
      name='user-admin-searcher'
      layout='horizontal'
      css={rootStyles}
    >
      <Row align='bottom' gutter={[10, 0]}>
        <Col
          css={css`
            width: 40rem;
          `}
        >
          <Form.Item
            label='Vai trò'
            name='roleId'
            initialValue=''
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Select
              showSearch
              allowClear
              placeholder='Chọn vai trò'
              optionFilterProp='label'
              options={rolesOptions}
              onClear={handleClear}
            />
          </Form.Item>
        </Col>
        <Col>
          <Button
            type='primary'
            icon={<SearchOutlined />}
            iconPosition='start'
            onClick={handleSearch}
          >
            Tìm kiếm
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

const rootStyles = css`
  .ant-form-item-label {
    padding: 0;
    label {
      height: auto;
    }
  }
  .ant-form-item {
    margin-bottom: 0;
  }
`;
